/* eslint-disable @typescript-eslint/no-deprecated */
/**
 * Array of panel names rendered in the page component.
 * @public
 * @deprecated Deprecated along with the `Page` component and will be removed in a future release.
 */
export const pagePanels = ['sidebar', 'main', 'details'] as const;

/**
 * @public
 * @deprecated Deprecated along with the `Page` component and will be removed in a future release.
 */
export type PanelName = (typeof pagePanels)[number];

/**
 * An object of panel keys and the panel's current size in all available units.
 * @public
 * @deprecated Deprecated along with the `Page` component and will be removed in a future release.
 */
export type PagePanelSizes = Record<string, { [key in 'px' | '%']: number }>;

/**
 * Page panels that can be dismissed.
 * @public
 * @deprecated This type is no longer used and will be removed in a future release.
 */
export type DismissiblePagePanels = Extract<
  (typeof pagePanels)[number],
  'sidebar' | 'details'
>;

/**
 * @public
 * @deprecated Deprecated along with the `Page` component and will be removed in a future release.
 */
export type ControlledPagePanelProps = {
  /** If the panel is opened. */
  dismissed: boolean;
  /** If the panel is dismissed by default. */
  defaultDismissed?: never;
};

/**
 * @public
 * @deprecated Deprecated along with the `Page` component and will be removed in a future release.
 */
export type UncontrolledPagePanelProps = {
  /** If the panel is opened. */
  dismissed?: never;
  /** If the panel is dismissed by default. */
  defaultDismissed?: boolean;
};

/**
 * @public
 * @deprecated Use `ControlledPagePanelProps` or `UncontrolledPagePanelProps` instead.
 **/
export type PagePanelProps =
  | ControlledPagePanelProps
  | UncontrolledPagePanelProps;
